module.exports = __webpack_public_path__ + "static/media/leperche-logo.c8a4749b.png";